import { createAction } from 'redux-actions';
import {
    RECEIVE_DATA
} from '../constants/actionTypes';


export const receiveData = createAction(RECEIVE_DATA);




// WEBPACK FOOTER //
// ./src/client/actions/getData.js